/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeMemberStatusResponse
 */
export interface ChallengeMemberStatusResponse {
    /**
     * True when the partner UID maps to a DevourPlay User AND that User has a ChallengeMembership for this slug.
     * @type {boolean}
     * @memberof ChallengeMemberStatusResponse
     */
    hasMembership: boolean;
    /**
     * True when the existing membership carries `acceptedTermsAt`. Tells the modal it can hide the universal attestation checkboxes.
     * @type {boolean}
     * @memberof ChallengeMemberStatusResponse
     */
    attestationOnFile: boolean;
    /**
     * True when `declaredCountry` is set on the membership. Tells the modal it can hide the Country (and State) pickers.
     * @type {boolean}
     * @memberof ChallengeMemberStatusResponse
     */
    countryOnFile: boolean;
    /**
     * True only when `declaredCountry === "US"` is on file but `declaredState` is missing — the modal should show only the State picker. Defensive; the register handler enforces state-when-US so this should rarely fire.
     * @type {boolean}
     * @memberof ChallengeMemberStatusResponse
     */
    stateRequired: boolean;
    /**
     * True when the modal can use the codeless "Continue" path (POST /challenges/{slug}/realm-signin — no verification code). Always true for an embed visitor: returning members resolve realmUuid-first, and new visitors are optimistically codeless (if their UUID has no Realm email, realm-signin returns 422 and the modal falls back to email + code). Absent only for non-embed web visitors (no handshake).
     * @type {boolean}
     * @memberof ChallengeMemberStatusResponse
     */
    canCodeless?: boolean;
}

/**
 * Check if a given object implements the ChallengeMemberStatusResponse interface.
 */
export function instanceOfChallengeMemberStatusResponse(value: object): value is ChallengeMemberStatusResponse {
    if (!('hasMembership' in value) || value['hasMembership'] === undefined) return false;
    if (!('attestationOnFile' in value) || value['attestationOnFile'] === undefined) return false;
    if (!('countryOnFile' in value) || value['countryOnFile'] === undefined) return false;
    if (!('stateRequired' in value) || value['stateRequired'] === undefined) return false;
    return true;
}

export function ChallengeMemberStatusResponseFromJSON(json: any): ChallengeMemberStatusResponse {
    return ChallengeMemberStatusResponseFromJSONTyped(json, false);
}

export function ChallengeMemberStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeMemberStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasMembership': json['hasMembership'],
        'attestationOnFile': json['attestationOnFile'],
        'countryOnFile': json['countryOnFile'],
        'stateRequired': json['stateRequired'],
        'canCodeless': json['canCodeless'] == null ? undefined : json['canCodeless'],
    };
}

export function ChallengeMemberStatusResponseToJSON(json: any): ChallengeMemberStatusResponse {
    return ChallengeMemberStatusResponseToJSONTyped(json, false);
}

export function ChallengeMemberStatusResponseToJSONTyped(value?: ChallengeMemberStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasMembership': value['hasMembership'],
        'attestationOnFile': value['attestationOnFile'],
        'countryOnFile': value['countryOnFile'],
        'stateRequired': value['stateRequired'],
        'canCodeless': value['canCodeless'],
    };
}

